<template>
    <div class="traceability-contract-view-page">
        <base-header
            :titulo="translate('individual_record.title')"
            icon="el-icon-document-add"
            :voltarPara="true"
        />
        <div class="view-container-wrapper">
            <div class="content">
                <h3>{{ translate('individual_record.export_data') }}</h3>
                <el-form class="individual-record_card"
                         autocomplete="off"
                         :disabled="isLocked"
                >
                    <div>
                        <element class="individual-record_row">
                            <el-form-item class="invoice-modal-item">
                                <label class="invoice-modal-mandatory">
                                    {{ translate('traceabilityReport.origin_port') }} <span>*</span>
                                </label>
                                <el-select
                                    v-model="exportData.origin_port"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.select_origin_port'
                                        )
                                    "
                                    clearable
                                    filterable
                                >
                                    <el-option
                                        v-for="silo in silos"
                                        :label="silo.unidade"
                                        :value="silo.id"
                                        :key="silo.id"
                                    >
                                        {{ silo.unidade }}
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item class="invoice-modal-item">
                                <label class="invoice-modal-mandatory">
                                    {{ translate('traceabilityReport.destination_port') }} <span>*</span>
                                </label>
                                <el-input
                                    v-model="exportData.destination_port"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.enter_destination_port'
                                        )
                                    "
                                    type="text"
                                    autocomplete="off"
                                />
                            </el-form-item>

                            <el-form-item class="invoice-modal-item">
                                <label class="invoice-modal-mandatory">
                                    {{ translate('traceabilityReport.counterparty') }} <span>*</span>
                                </label>
                                <el-input
                                    v-model="exportData.counterparty"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.enter_counterparty'
                                        )
                                    "
                                    type="text"
                                    autocomplete="off"
                                />
                            </el-form-item>
                        </element>

                        <element class="individual-record_row">
                            <el-form-item class="invoice-modal-item">
                                <label class="invoice-modal-mandatory"
                                    >{{
                                        translate('individual_record.product')
                                    }}
                                    <span>*</span></label
                                >
                                <el-select
                                    v-model="exportData.product"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.select_product'
                                        )
                                    "
                                    clearable
                                    filterable
                                >
                                    <el-option
                                        v-for="cultivation in products"
                                        :value="cultivation.codigo"
                                        :key="cultivation.codigo"
                                        :label="translate(`traceabilityReport.product_codes.${cultivation.codigo.toLowerCase()}`)"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item class="invoice-modal-item">
                                <label class="invoice-modal-mandatory"
                                    >{{
                                        translate('individual_record.harvest')
                                    }}
                                    <span>*</span></label
                                >
                                <el-select
                                    v-model="exportData.harvest"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.select_harvest'
                                        )
                                    "
                                    clearable
                                    filterable
                                >
                                    <el-option
                                        v-for="h in harvest"
                                        :value="h.id"
                                        :key="h.id"
                                        :label="harvestLabel(h)"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item class="invoice-modal-item">
                                <label class="invoice-modal-mandatory">
                                    {{ translate('traceabilityReport.cargo_volume') }} <span>*</span>
                                </label>
                                <el-input
                                    v-model="exportData.cargo_volume"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.enter_volume_ton'
                                        )
                                    "
                                    type="number"
                                    min="0"
                                />
                            </el-form-item>
                        </element>

                        <element class="individual-record_row_single_field">
                            <el-form-item class="invoice-modal-item">
                                <label>{{
                                    translate('individual_record.description')
                                }}</label>
                                <el-input
                                    v-model="exportData.description"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.enter_description'
                                        )
                                    "
                                />
                            </el-form-item>
                        </element>
                    </div>

                    <el-divider border-style="solid" />

                    <div class="individual-record_bl_section">
                        <span class="individual-record_section_label">{{
                            translate('individual_record.bill_of_landing')
                        }}</span>
                        <element class="individual-record_row">
                            <el-form-item class="invoice-modal-item">
                                <label class="invoice-modal-mandatory"
                                    >{{
                                        translate('traceabilityReport.bl_number')
                                    }}
                                    <span>*</span></label
                                >
                                <el-input
                                    v-model="blNumberModel"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.enter_bl_number'
                                        )
                                    "
                                    type="text"
                                    autocomplete="off"
                                />
                            </el-form-item>

                            <el-form-item class="invoice-modal-item">
                                <label class="invoice-modal-mandatory"
                                    >{{
                                        translate('traceabilityReport.bl_date')
                                    }}
                                    <span>*</span></label
                                >
                                <el-date-picker
                                    v-model="exportData.bl_date"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.select_bl_date'
                                        )
                                    "
                                    type="date"
                                    format="dd/MM/yyyy"
                                />
                            </el-form-item>

                            <el-form-item class="invoice-modal-item">
                                <label>{{
                                    translate(
                                        'individual_record.export_approval_number'
                                    )
                                }}</label>
                                <el-input
                                    v-model="approvalNumberModel"
                                    :placeholder="
                                        $t(
                                            'relatorio_rastreabilidade.messages.common.enter_approval_export_number'
                                        )
                                    "
                                    type="text"
                                    autocomplete="off"
                                />
                            </el-form-item>
                        </element>
                    </div>
                </el-form>
                <div class="finish-button-container" v-if="!this.isLocked">
                    <el-button
                        class="finish-button"
                        type="primary"
                        @click="finishRecord"
                        :disabled="checkMandatoryInfo()"
                    >
                        {{ translate('individual_record.finish') }}
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import UtilsService from '@/services/UtilsService';
import { mapActions, mapGetters, mapState } from 'vuex';
import formatters from '@/utils/formatters';

export default {
    data() {
        return {
            exportData: {
                origin_port: null,
                destination_port: null,
                counterparty: null,
                product: null,
                harvest: null,
                cargo_volume: null,
                description: null,
                bl_number: null,
                bl_date: null,
                approval_number: null
            },
            filteredCompanies: [],
            harvest: {},
            isLocked: false,
            isFinished: false
        };
    },
    components: {
        BaseHeader: () => import('@/components/BaseHeader')
    },
    computed: {
        ...mapState('relatorioRastreabilidadeModule', [
            'silos',
            'products',
            'individualExport'
        ]),
        ...mapGetters(['empresasSubEmpresasPorPais', 'usuarioLogado']),
        blNumberModel: {
            get() {
                return this.exportData.bl_number;
            },
            set(value) {
                this.exportData.bl_number = this.limitLength(value);
            }
        },
        approvalNumberModel: {
            get() {
                return this.exportData.approval_number;
            },
            set(value) {
                this.exportData.approval_number = this.limitLength(value);
            }
        }
    },
    mounted() {
        this.$store.commit('relatorioRastreabilidadeModule/SET_TYPE_LIST', [
            'PORTO'
        ]);
        this.fetchSilo();
        this.fetchProducts();
        this.fetchHarvest();

        if (this.empresasSubEmpresasPorPais.length === 0) {
            this.fetchCompaniesAndSubCompanies();
        } else {
            this.filteredCompanies = this.empresasSubEmpresasPorPais;
        }

        if (this.$route.params.id) {
            this.isLocked = true;
            this.buscarRegistro();
        }
    },
    methods: {
        ...mapActions(['fetchEmpresasSubEmpresasPorPais']),
        ...mapActions('relatorioRastreabilidadeModule', [
            'fetchSilo',
            'fetchProducts',
            'createIndividualExportRecord',
            'fetchIndividualExportRecordById'
        ]),
        translate(key, params = {}) {
            const base = 'relatorio_rastreabilidade.messages';
            const translated = this.$t(`${base}.${key}`, params);
            return translated !== `${base}.${key}`
                ? translated
                : this.$t(`relatorio_rastreabilidade.${key}`, params);
        },
        harvestLabel(h) {
            const suffix = h.descricao?.split(' ')?.[1] ?? h.ano;
            return `${this.translate('traceabilityReport.crop')} ${suffix}`;
        },
        limitLength(value) {
            return (value || '').slice(0, 20);
        },
        async finishRecord() {
            this.$store.commit(
                'relatorioRastreabilidadeModule/SET_INDIVIDUAL_EXPORT',
                {
                    ...this.exportData
                }
            );
            if (!this.checkMandatoryInfo()) {
                this.isFinished = true;
                await this.createIndividualExportRecord()
                    .then(resultado => {
                        this.$notify.success({
                            message: this.translate(
                                'individual_record.registration_success'
                            ),
                            duration: 6000
                        });
                        this.$router.push({
                            name: 'RelatorioRastreabilidade'
                        });
                    })
                    .catch(error => {
                        this.isFinished = false;
                        const code = (error && error.response && error.response.data && error.response.data.message) || error?.decodedMessage;
                        const message = code
                            ? this.translate('individual_record.error.' + code)
                            : this.translate('individual_record.error.error_message');
                        this.$notify.error({ message, duration: 6000 });
                    });
            }
        },
        async fetchCompaniesAndSubCompanies() {
            if (this.empresasSubEmpresasPorPais.length === 0) {
                await this.fetchEmpresasSubEmpresasPorPais(
                    this.usuarioLogado.paisGrupo
                        ? this.usuarioLogado.paisGrupo
                        : 'PY'
                );
            }
            this.filteredCompanies = this.empresasSubEmpresasPorPais;
        },
        async fetchHarvest() {
            const { data } = await UtilsService.getSafrasVigentesSise();
            this.harvest = data.filter(safra => safra.tipoSafra === 'SAFRA');
        },
        checkMandatoryInfo() {
            const emptyExportData = (
                !this.exportData.origin_port ||
                !this.exportData.destination_port ||
                !this.exportData.destination_port.length === 0 ||
                !this.exportData.counterparty ||
                !this.exportData.counterparty.length === 0 ||
                !this.exportData.product ||
                !this.exportData.harvest ||
                !this.exportData.cargo_volume ||
                !this.exportData.cargo_volume.length === 0 ||
                !this.exportData.bl_number ||
                !this.exportData.bl_number.length === 0 ||
                !this.exportData.bl_date
            );
            if (emptyExportData || this.isFinished) return true;
            return false;
        },
        async buscarRegistro() {
            try {
                const id = this.$route.params.id;
                const data = await this.fetchIndividualExportRecordById(id);

                this.exportData.destination_port = data.portoDestino;
                this.exportData.counterparty = data.contraparte;
                this.exportData.cargo_volume = data.volumeTon;
                this.exportData.description = data.descricao;
                this.exportData.bl_number = data.numeroBl;
                this.exportData.approval_number = data.numeroAprovacao;
                this.exportData.bl_date = formatters.localDateToDatePicker(
                    data.dataBl
                );

                this.exportData.product = data.codigoProduto;
                this.exportData.origin_port = data.idPortoOrigem;
                this.exportData.harvest = data.idSafra;
            } catch (error) {
                const code =
                    (error && error.response && error.response.data && error.response.data.message) ||
                    'fetch_record';
                this.$notify.error({
                    message: this.translate('individual_record.error.' + code),
                    duration: 6000
                });
            }
        }
    }
};
</script>
<style scoped lang="scss">
.traceability-contract-view-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }

    .individual-record_section_label {
        font-weight: 500;
    }

    .individual-record_card {
        padding: 32px;
        background: white;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-items: center;
        font-size: 14px;

        .individual-record_bl_section {
        }

        .individual-record_row {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 24px;
        }
    }
    h3 {
        margin-top: 5px;
        font-weight: 500;
    }
}
.invoice-modal-item {
    flex: 1;
    .el-select,
    .el-input {
        width: 100%;
    }
}

.el-divider {
    margin-top: 7px;
    margin-bottom: 11px;
}

.finish-button-container {
    display: flex;
    flex-direction: row-reverse;
    .finish-button {
        width: 100px;
    }
}

.invoice-modal-mandatory span {
    color: var(--danger);
}
</style>
